export default "__VITE_ASSET__DoW3$0tB__"